import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTableCustomClassifications extends Layout {
    sourceClassifications: DataSource;
    customClassificationTable: Table;
}
